module.exports = __webpack_public_path__ + "static/media/facebook.53757d93.svg";